module.exports = __webpack_public_path__ + "static/media/1POLICY28.9bd1a660.jpg";